export type TrendingCategory = 'radios' | 'locutores' | 'programas' | 'eventos' | 'concursos';

export type TrendDirection = 'exploding' | 'up' | 'stable' | 'down';

export interface TrendingItem {
  id: number;
  name: string;
  category: TrendingCategory;
  subtitle: string;
  trendScore: number;
  growthPercent: number;
  trendDirection: TrendDirection;
  socialSignals: { comments: number; shares: number; mentions: number };
  rank: number;
  rankChange: number;
  thumbnailUrl: string;
  badge: string;
}

export interface TrendingSummary {
  totalTrending: number;
  categoriesActive: number;
  totalSocialMentions: number;
  avgGrowthPercent: number;
  hottestCategory: string;
  topItem: string;
}

export const trendingSummary: TrendingSummary = {
  totalTrending: 28,
  categoriesActive: 5,
  totalSocialMentions: 48620,
  avgGrowthPercent: 34,
  hottestCategory: 'locutores',
  topItem: 'Isabella Torres',
};

export const trendingItems: TrendingItem[] = [
  {
    id: 1,
    name: 'Isabella Torres',
    category: 'locutores',
    subtitle: 'Radio Éxito FM · 98.7 FM',
    trendScore: 97,
    growthPercent: 62,
    trendDirection: 'exploding',
    socialSignals: { comments: 3840, shares: 2150, mentions: 5200 },
    rank: 1,
    rankChange: 5,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20broadcaster%20portrait%20with%20headphones%20in%20modern%20studio%2C%20warm%20amber%20studio%20lighting%2C%20confident%20expression%2C%20editorial%20photography%20style%20with%20soft%20depth%20of%20field%2C%20clean%20neutral%20background&width=200&height=200&seq=trending-bc-01&orientation=squarish',
    badge: 'Crecimiento Explosivo',
  },
  {
    id: 2,
    name: 'Radio Juvenil FM',
    category: 'radios',
    subtitle: '105.3 FM · Música Juvenil',
    trendScore: 94,
    growthPercent: 48,
    trendDirection: 'exploding',
    socialSignals: { comments: 5620, shares: 3180, mentions: 8900 },
    rank: 2,
    rankChange: 8,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Vibrant%20modern%20radio%20station%20exterior%20with%20colorful%20neon%20signage%20at%20night%2C%20urban%20youth%20culture%20aesthetic%2C%20trendy%20architecture%2C%20warm%20glowing%20windows%2C%20editorial%20photography&width=200&height=200&seq=trending-rd-01&orientation=squarish',
    badge: 'Viral',
  },
  {
    id: 3,
    name: 'Carrusel Deportivo',
    category: 'programas',
    subtitle: 'Radio Deportiva Total · Lun-Vie 18:00',
    trendScore: 92,
    growthPercent: 55,
    trendDirection: 'exploding',
    socialSignals: { comments: 4200, shares: 2800, mentions: 6100 },
    rank: 3,
    rankChange: 3,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20radio%20show%20studio%20with%20multiple%20microphones%20and%20large%20screens%20showing%20match%20highlights%2C%20energetic%20atmosphere%2C%20professional%20broadcast%20setup%2C%20warm%20studio%20lighting&width=200&height=200&seq=trending-pg-01&orientation=squarish',
    badge: 'Tendencia #1',
  },
  {
    id: 4,
    name: 'Concurso La Voz RFW 2026',
    category: 'concursos',
    subtitle: 'RFW · Inscripciones Abiertas',
    trendScore: 90,
    growthPercent: 72,
    trendDirection: 'exploding',
    socialSignals: { comments: 8900, shares: 5600, mentions: 12400 },
    rank: 4,
    rankChange: 12,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Exciting%20singing%20competition%20stage%20with%20spotlights%20and%20golden%20microphone%2C%20grand%20theater%20setting%2C%20dramatic%20lighting%2C%20concert%20atmosphere%2C%20professional%20event%20photography&width=200&height=200&seq=trending-cc-01&orientation=squarish',
    badge: 'Explosión Social',
  },
  {
    id: 5,
    name: 'Felipe Gutiérrez',
    category: 'locutores',
    subtitle: 'Estéreo Capital · 92.1 FM',
    trendScore: 88,
    growthPercent: 41,
    trendDirection: 'up',
    socialSignals: { comments: 3100, shares: 1800, mentions: 4200 },
    rank: 5,
    rankChange: 7,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Charismatic%20male%20radio%20host%20speaking%20into%20microphone%20in%20professional%20studio%2C%20warm%20lighting%2C%20genuine%20smile%2C%20modern%20broadcast%20environment%2C%20editorial%20portrait%20style&width=200&height=200&seq=trending-bc-02&orientation=squarish',
    badge: 'En Ascenso',
  },
  {
    id: 6,
    name: 'Festival Sonoro RFW',
    category: 'eventos',
    subtitle: 'Bogotá · 15 Julio 2026',
    trendScore: 87,
    growthPercent: 58,
    trendDirection: 'exploding',
    socialSignals: { comments: 6700, shares: 4200, mentions: 9800 },
    rank: 6,
    rankChange: 4,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Massive%20outdoor%20music%20festival%20crowd%20with%20colorful%20stage%20lights%20at%20sunset%2C%20thousands%20of%20people%2C%20festival%20vibes%2C%20wide%20angle%20aerial%20perspective%2C%20epic%20concert%20photography&width=200&height=200&seq=trending-ev-01&orientation=squarish',
    badge: 'Imperdible',
  },
  {
    id: 7,
    name: 'Estéreo Capital',
    category: 'radios',
    subtitle: '92.1 FM · Música y Cultura',
    trendScore: 85,
    growthPercent: 36,
    trendDirection: 'up',
    socialSignals: { comments: 4800, shares: 2600, mentions: 7100 },
    rank: 7,
    rankChange: 2,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Sophisticated%20radio%20station%20building%20with%20modern%20glass%20architecture%20and%20cultural%20art%20installations%2C%20urban%20setting%2C%20golden%20hour%20lighting%2C%20editorial%20photography&width=200&height=200&seq=trending-rd-02&orientation=squarish',
    badge: 'Creciendo',
  },
  {
    id: 8,
    name: 'Despierta con Energía',
    category: 'programas',
    subtitle: 'Radio Éxito FM · Lun-Vie 06:00',
    trendScore: 83,
    growthPercent: 44,
    trendDirection: 'up',
    socialSignals: { comments: 3600, shares: 1900, mentions: 4800 },
    rank: 8,
    rankChange: 10,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Bright%20morning%20radio%20show%20studio%20with%20two%20hosts%20laughing%2C%20coffee%20cups%20on%20desk%2C%20sunny%20morning%20light%20streaming%20through%20window%2C%20energetic%20atmosphere&width=200&height=200&seq=trending-pg-02&orientation=squarish',
    badge: 'Morning Boost',
  },
  {
    id: 9,
    name: 'Javier Mendoza',
    category: 'locutores',
    subtitle: 'Radio Deportiva Total · 1010 AM',
    trendScore: 81,
    growthPercent: 33,
    trendDirection: 'up',
    socialSignals: { comments: 2900, shares: 1550, mentions: 3800 },
    rank: 9,
    rankChange: 6,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Passionate%20male%20sports%20broadcaster%20gesturing%20while%20speaking%2C%20headphones%20around%20neck%2C%20dynamic%20studio%20with%20sports%20memorabilia%2C%20professional%20lighting%2C%20editorial%20portrait&width=200&height=200&seq=trending-bc-03&orientation=squarish',
    badge: 'Voz Deportiva',
  },
  {
    id: 10,
    name: 'Noches de Rock',
    category: 'programas',
    subtitle: 'Radio Rock 360 · Mar-Jue 22:00',
    trendScore: 79,
    growthPercent: 51,
    trendDirection: 'up',
    socialSignals: { comments: 4100, shares: 2300, mentions: 5500 },
    rank: 10,
    rankChange: 15,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20radio%20studio%20with%20purple%20and%20red%20mood%20lighting%2C%20vinyl%20records%20on%20wall%2C%20electric%20guitar%20in%20background%2C%20rock%20music%20vibe%2C%20editorial%20photography&width=200&height=200&seq=trending-pg-03&orientation=squarish',
    badge: 'Escalando Rápido',
  },
  {
    id: 11,
    name: 'Concurso Mejor Podcast RFW',
    category: 'concursos',
    subtitle: 'RFW · Votación Abierta',
    trendScore: 78,
    growthPercent: 45,
    trendDirection: 'up',
    socialSignals: { comments: 5200, shares: 3400, mentions: 7200 },
    rank: 11,
    rankChange: 8,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Podcast%20award%20ceremony%20setup%20with%20golden%20trophies%20and%20microphones%20on%20red%20carpet%2C%20glamorous%20event%20lighting%2C%20professional%20photography%2C%20celebration%20atmosphere&width=200&height=200&seq=trending-cc-02&orientation=squarish',
    badge: 'Votación Activa',
  },
  {
    id: 12,
    name: 'Radio Noticias 24',
    category: 'radios',
    subtitle: '89.5 FM · Noticias',
    trendScore: 76,
    growthPercent: 29,
    trendDirection: 'up',
    socialSignals: { comments: 3400, shares: 2100, mentions: 5600 },
    rank: 12,
    rankChange: 4,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Professional%20news%20radio%20station%20with%20large%20world%20map%20display%20and%20multiple%20monitors%2C%20serious%20newsroom%20atmosphere%2C%20modern%20broadcast%20technology%2C%20editorial%20photography&width=200&height=200&seq=trending-rd-03&orientation=squarish',
    badge: 'Confianza',
  },
  {
    id: 13,
    name: 'María José Salazar',
    category: 'locutores',
    subtitle: 'Radio Clásica · 101.5 FM',
    trendScore: 74,
    growthPercent: 38,
    trendDirection: 'up',
    socialSignals: { comments: 2400, shares: 1350, mentions: 3100 },
    rank: 13,
    rankChange: 9,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Elegant%20female%20classical%20music%20radio%20host%20in%20sophisticated%20studio%2C%20warm%20acoustic%20panels%2C%20gentle%20lighting%2C%20refined%20atmosphere%2C%20editorial%20portrait%20photography&width=200&height=200&seq=trending-bc-04&orientation=squarish',
    badge: 'Elegancia al Aire',
  },
  {
    id: 14,
    name: 'Torneo de Djs RFW',
    category: 'eventos',
    subtitle: 'Medellín · 22 Agosto 2026',
    trendScore: 73,
    growthPercent: 65,
    trendDirection: 'exploding',
    socialSignals: { comments: 4500, shares: 2900, mentions: 6300 },
    rank: 14,
    rankChange: 18,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=DJ%20battle%20competition%20in%20nightclub%20with%20laser%20lights%20and%20smoke%20effects%2C%20turntables%20and%20mixer%2C%20excited%20crowd%2C%20electronic%20music%20event%2C%20dynamic%20concert%20photography&width=200&height=200&seq=trending-ev-02&orientation=squarish',
    badge: 'Nuevo',
  },
  {
    id: 15,
    name: 'Ecos del Campo',
    category: 'programas',
    subtitle: 'Radio Éxito FM · Sáb 08:00',
    trendScore: 71,
    growthPercent: 27,
    trendDirection: 'up',
    socialSignals: { comments: 1800, shares: 950, mentions: 2400 },
    rank: 15,
    rankChange: 1,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Rural%20radio%20program%20setting%20with%20wooden%20interior%20and%20folk%20instruments%2C%20warm%20natural%20light%2C%20traditional%20Latin%20American%20aesthetic%2C%20cozy%20atmosphere&width=200&height=200&seq=trending-pg-04&orientation=squarish',
    badge: 'Raíces',
  },
  {
    id: 16,
    name: 'Radio Rock 360',
    category: 'radios',
    subtitle: '96.8 FM · Rock Nacional',
    trendScore: 70,
    growthPercent: 42,
    trendDirection: 'up',
    socialSignals: { comments: 3900, shares: 2400, mentions: 5800 },
    rank: 16,
    rankChange: 11,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Edgy%20rock%20radio%20station%20studio%20with%20graffiti%20wall%20art%20and%20vintage%20guitar%20collection%2C%20industrial%20loft%20style%2C%20rebel%20aesthetic%2C%20editorial%20photography&width=200&height=200&seq=trending-rd-04&orientation=squarish',
    badge: 'Resurgiendo',
  },
  {
    id: 17,
    name: 'Camila Restrepo',
    category: 'locutores',
    subtitle: 'Radio Juvenil FM · 105.3 FM',
    trendScore: 68,
    growthPercent: 53,
    trendDirection: 'up',
    socialSignals: { comments: 3500, shares: 2000, mentions: 4600 },
    rank: 17,
    rankChange: 14,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Young%20energetic%20female%20radio%20host%20with%20colorful%20headphones%2C%20modern%20casual%20style%2C%20bright%20studio%20with%20LED%20lights%2C%20youth%20culture%20vibe%2C%20editorial%20portrait&width=200&height=200&seq=trending-bc-05&orientation=squarish',
    badge: 'Revelación',
  },
  {
    id: 18,
    name: 'Encuentro de Radios Comunitarias',
    category: 'eventos',
    subtitle: 'Cali · 3 Septiembre 2026',
    trendScore: 66,
    growthPercent: 31,
    trendDirection: 'up',
    socialSignals: { comments: 2100, shares: 1300, mentions: 2900 },
    rank: 18,
    rankChange: 5,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Community%20radio%20gathering%20in%20tropical%20outdoor%20setting%20with%20banners%20and%20people%20networking%2C%20warm%20sunlight%2C%20Latin%20American%20cultural%20event%2C%20documentary%20photography&width=200&height=200&seq=trending-ev-03&orientation=squarish',
    badge: 'Comunidad',
  },
  {
    id: 19,
    name: 'Concurso Creatividad Sonora',
    category: 'concursos',
    subtitle: 'RFW · Recepción de Propuestas',
    trendScore: 65,
    growthPercent: 39,
    trendDirection: 'up',
    socialSignals: { comments: 2800, shares: 1700, mentions: 3800 },
    rank: 19,
    rankChange: 7,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Creative%20audio%20production%20contest%20setup%20with%20mixing%20console%20and%20award%20certificates%2C%20colorful%20sound%20wave%20visualizations%2C%20modern%20studio%2C%20innovative%20atmosphere&width=200&height=200&seq=trending-cc-03&orientation=squarish',
    badge: 'Creatividad',
  },
  {
    id: 20,
    name: 'Tardes de Concierto',
    category: 'programas',
    subtitle: 'Radio Clásica · Dom 16:00',
    trendScore: 64,
    growthPercent: 22,
    trendDirection: 'up',
    socialSignals: { comments: 1500, shares: 780, mentions: 2000 },
    rank: 20,
    rankChange: 3,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Classical%20music%20radio%20program%20with%20grand%20piano%20and%20cello%20in%20elegant%20studio%2C%20candlelight%20ambiance%2C%20sophisticated%20aesthetic%2C%20warm%20golden%20lighting&width=200&height=200&seq=trending-pg-05&orientation=squarish',
    badge: 'Clásico Vivo',
  },
  {
    id: 21,
    name: 'Radio Deportiva Total',
    category: 'radios',
    subtitle: '1010 AM · Deportes',
    trendScore: 63,
    growthPercent: 18,
    trendDirection: 'stable',
    socialSignals: { comments: 4100, shares: 2500, mentions: 6200 },
    rank: 21,
    rankChange: -2,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Sports%20radio%20station%20with%20trophy%20cabinet%20and%20team%20jerseys%20on%20display%2C%20dynamic%20sports%20memorabilia%2C%20professional%20broadcast%20environment%2C%20editorial%20photography&width=200&height=200&seq=trending-rd-05&orientation=squarish',
    badge: 'Consolidado',
  },
  {
    id: 22,
    name: 'Expo Tecnología y Radio',
    category: 'eventos',
    subtitle: 'Buenos Aires · 18 Octubre 2026',
    trendScore: 61,
    growthPercent: 47,
    trendDirection: 'up',
    socialSignals: { comments: 1900, shares: 1150, mentions: 2600 },
    rank: 22,
    rankChange: 13,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Technology%20expo%20with%20broadcast%20equipment%20displays%20and%20interactive%20demos%2C%20modern%20convention%20center%2C%20professional%20networking%20event%2C%20innovative%20atmosphere&width=200&height=200&seq=trending-ev-04&orientation=squarish',
    badge: 'Innovación',
  },
  {
    id: 23,
    name: 'Gabriel Paredes',
    category: 'locutores',
    subtitle: 'Radio Noticias 24 · 89.5 FM',
    trendScore: 60,
    growthPercent: 25,
    trendDirection: 'up',
    socialSignals: { comments: 2000, shares: 1100, mentions: 2700 },
    rank: 23,
    rankChange: 4,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Serious%20male%20news%20anchor%20at%20desk%20with%20papers%20and%20microphone%2C%20professional%20newsroom%20background%2C%20trustworthy%20expression%2C%20editorial%20portrait&width=200&height=200&seq=trending-bc-06&orientation=squarish',
    badge: 'Credibilidad',
  },
  {
    id: 24,
    name: 'Concurso Frases al Aire',
    category: 'concursos',
    subtitle: 'RFW · Participación Diaria',
    trendScore: 58,
    growthPercent: 34,
    trendDirection: 'up',
    socialSignals: { comments: 3200, shares: 1800, mentions: 4400 },
    rank: 24,
    rankChange: -1,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Fun%20radio%20contest%20with%20colorful%20prize%20wheel%20and%20gift%20boxes%2C%20excited%20callers%20on%20phone%20lines%2C%20lively%20studio%20atmosphere%2C%20game%20show%20vibe&width=200&height=200&seq=trending-cc-04&orientation=squarish',
    badge: 'Participativo',
  },
  {
    id: 25,
    name: 'Radio Éxito FM',
    category: 'radios',
    subtitle: '98.7 FM · Éxitos',
    trendScore: 56,
    growthPercent: 14,
    trendDirection: 'stable',
    socialSignals: { comments: 5100, shares: 2900, mentions: 7400 },
    rank: 25,
    rankChange: -3,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Popular%20mainstream%20radio%20station%20with%20large%20hit%20music%20billboard%20and%20modern%20design%2C%20urban%20storefront%2C%20golden%20hour%20lighting%2C%20editorial%20photography&width=200&height=200&seq=trending-rd-06&orientation=squarish',
    badge: 'Líder',
  },
  {
    id: 26,
    name: 'Gala Anual RFW',
    category: 'eventos',
    subtitle: 'CDMX · 5 Diciembre 2026',
    trendScore: 55,
    growthPercent: 28,
    trendDirection: 'up',
    socialSignals: { comments: 1600, shares: 900, mentions: 2200 },
    rank: 26,
    rankChange: 6,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Elegant%20award%20gala%20dinner%20with%20round%20tables%20and%20stage%2C%20golden%20decorations%2C%20formal%20attire%20crowd%2C%20luxurious%20ballroom%2C%20event%20photography&width=200&height=200&seq=trending-ev-05&orientation=squarish',
    badge: 'Gala',
  },
  {
    id: 27,
    name: 'Concurso Foto del Oyente',
    category: 'concursos',
    subtitle: 'RFW · Instagram',
    trendScore: 53,
    growthPercent: 26,
    trendDirection: 'up',
    socialSignals: { comments: 2500, shares: 1400, mentions: 3500 },
    rank: 27,
    rankChange: 2,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Photo%20contest%20display%20with%20polaroid%20pictures%20on%20string%20lights%2C%20creative%20social%20media%20wall%2C%20colorful%20and%20fun%20atmosphere%2C%20community%20engagement&width=200&height=200&seq=trending-cc-05&orientation=squarish',
    badge: 'Social',
  },
  {
    id: 28,
    name: 'Hora Cero',
    category: 'programas',
    subtitle: 'Radio Noticias 24 · Lun-Vie 00:00',
    trendScore: 51,
    growthPercent: 19,
    trendDirection: 'stable',
    socialSignals: { comments: 2200, shares: 1200, mentions: 3100 },
    rank: 28,
    rankChange: -1,
    thumbnailUrl: 'https://readdy.ai/api/search-image?query=Late%20night%20news%20radio%20studio%20with%20dim%20blue%20lighting%20and%20large%20clock%2C%20serious%20atmosphere%2C%20night%20shift%20broadcast%2C%20editorial%20photography&width=200&height=200&seq=trending-pg-06&orientation=squarish',
    badge: 'Nocturno',
  },
];

export const categoryLabels: Record<TrendingCategory, string> = {
  radios: 'Radios',
  locutores: 'Locutores',
  programas: 'Programas',
  eventos: 'Eventos',
  concursos: 'Concursos',
};

export const categoryIcons: Record<TrendingCategory, string> = {
  radios: 'ri-radio-line',
  locutores: 'ri-user-voice-line',
  programas: 'ri-mic-line',
  eventos: 'ri-calendar-event-line',
  concursos: 'ri-trophy-line',
};

export const directionConfig: Record<TrendDirection, { label: string; color: string; icon: string; bg: string }> = {
  exploding: { label: 'Explosivo', color: 'text-rose-600', icon: 'ri-fire-line', bg: 'bg-rose-50' },
  up: { label: 'En Ascenso', color: 'text-emerald-600', icon: 'ri-arrow-up-line', bg: 'bg-emerald-50' },
  stable: { label: 'Estable', color: 'text-amber-600', icon: 'ri-subtract-line', bg: 'bg-amber-50' },
  down: { label: 'Descendiendo', color: 'text-stone-500', icon: 'ri-arrow-down-line', bg: 'bg-stone-50' },
};